import React, { useState } from 'react'
import PostCommunityManagement from '../components/PostCommunityManagement/PostCommunityManagement'

const PostCommunityManagementPage = () => {
  return <PostCommunityManagement />
}

export default PostCommunityManagementPage
